module.exports = __webpack_public_path__ + "img/logo-mark.3685a8b3.png";